/* ==========================================================================
   Ultrabooty pop-ups — markup in snippets/ub-popups.liquid, styles in ub-popups.css.

   One pop-up per visitor, chosen once and remembered:
     quiz  (share = data-quiz-share %)   Goal → Email → Unlocked → ORDER YOURS NOW
     lead  (the rest, headline A–D)      Gate → Unlocked → ORDER YOURS NOW
   ORDER YOURS NOW: exactly 1 unit in the cart (never a second), then the theme's cart drawer.
   Shows at data-scroll-percent of the page, or after data-fallback-seconds.
   Closing snoozes it for data-snooze-days; finishing it (email sent) ends it for good.
   Preview: ?ub_popup=quiz | quiz2 (= quiz, opens after 2 s) | mystery | lead | lead-a … lead-d opens it now; ?ub_popup=reset forgets.
   Real flow (waits for the trigger): ?ub_flow=quiz | mystery | lead | lead-a … lead-d.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('ub-popups');
  if (!root) return;
  var tab = document.getElementById('ub-popup-tab');

  var KEY_ASSIGN = 'ub_popup_assign';
  var KEY_SNOOZE = 'ub_popup_snooze_until';
  var KEY_DONE = 'ub_popup_done';
  var KEY_TAB = 'ub_popup_tab_hidden_until';
  var KLAVIYO_REVISION = '2024-10-15';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function cfg(name, fallback) {
    var v = root.getAttribute('data-' + name);
    return v === null || v === '' ? fallback : v;
  }
  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      if (value === null) localStorage.removeItem(key); else localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  /* ---------- Who sees what ---------- */
  var params = new URLSearchParams(location.search);
  var forced = (params.get('ub_popup') || '').toLowerCase();
  if (forced === 'reset') { [KEY_ASSIGN, KEY_SNOOZE, KEY_DONE, KEY_TAB].forEach(function (k) { store(k, null); }); forced = ''; }

  // ?ub_flow=quiz | mystery | lead | lead-a … lead-d — test the real experience: picks the
  // pop-up and clears "seen", but it still waits for the scroll / time trigger like any visitor.
  var flow = (params.get('ub_flow') || '').toLowerCase().match(/^(quiz|mystery|lead)(?:-([abcd]))?$/);
  if (flow) {
    store(KEY_DONE, null);
    store(KEY_SNOOZE, null);
    store(KEY_TAB, null);
    store(KEY_ASSIGN, JSON.stringify(
      flow[1] === 'lead' ? { type: 'lead', variant: (flow[2] || 'a').toUpperCase() }
        : { type: 'quiz', variant: flow[1] === 'mystery' ? 'mystery' : 'standard' }));
  }

  function variants() {
    var list = cfg('lead-variants', 'A,B,C,D').split(',').filter(function (v) { return /^[ABCD]$/.test(v); });
    return list.length ? list : ['A'];
  }
  function quizVariants() {
    var list = cfg('quiz-variants', 'standard,mystery').split(',').filter(function (v) { return v === 'standard' || v === 'mystery'; });
    return list.length ? list : ['standard'];
  }
  function pickQuiz() { var l = quizVariants(); return { type: 'quiz', variant: l[Math.floor(Math.random() * l.length)] }; }
  function assign() {
    if (forced === 'quiz') return { type: 'quiz', variant: 'standard' };
    if (forced === 'mystery') return { type: 'quiz', variant: 'mystery' };
    if (forced === 'quiz2') return { type: 'quiz', variant: 'standard' };
    var m = forced.match(/^lead(?:-([abcd]))?$/);
    if (m) return { type: 'lead', variant: m[1] ? m[1].toUpperCase() : variants()[0] };
    try {
      var saved = JSON.parse(store(KEY_ASSIGN) || 'null');
      if (saved && saved.type === 'quiz' && quizVariants().indexOf(saved.variant) > -1) return saved;
      if (saved && saved.type === 'lead' && variants().indexOf(saved.variant) > -1) return saved;
    } catch (e) {}
    var share = Math.max(0, Math.min(100, Number(cfg('quiz-share', 50))));
    var pick = Math.random() * 100 < share
      ? pickQuiz()
      : { type: 'lead', variant: variants()[Math.floor(Math.random() * variants().length)] };
    store(KEY_ASSIGN, JSON.stringify(pick));
    return pick;
  }
  var who = assign();
  var label = who.type + '-' + who.variant;   // quiz-standard · quiz-mystery · lead-A … lead-D

  /* ---------- A/B counts → omnisend-lead /api/popup-event ----------
     Unique visitors per version and step (no cookies, no personal data). Forced previews (?ub_popup=, ?ub_flow=)
     never count; the unpublished theme counts as "preview"; ?ub_stats=test counts anything as "test". */
  var STEPS = { 'Viewed': 'view', 'Chose Goal': 'goal', 'Signed Up': 'signup', 'Clicked Order Yours Now': 'order_click',
    'Closed': 'close', 'Reopened From Tab': 'tab_reopen' };
  var statsEnv = params.get('ub_stats') === 'test' ? 'test'
    : window.Shopify && Shopify.theme && Shopify.theme.role === 'main' ? 'live' : 'preview';
  var counting = statsEnv === 'test' || !(forced || flow);
  function visitorId() {
    var v = store('ub_vid');
    if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); store('ub_vid', v); }
    return v;
  }
  function stat(action) {
    var step = STEPS[action], url = cfg('stats-endpoint', '');
    if (!step || !url || !counting) return;
    var body = JSON.stringify({ v: label, s: step, id: visitorId(), env: statsEnv });
    try { if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return; } catch (e) {}
    fetch(url, { method: 'POST', body: body, keepalive: true, headers: { 'content-type': 'text/plain' } }).catch(function () {});
  }

  /* ---------- Version on the cart → the order's "Additional details" (ub_popup_variant) ----------
     Every assigned visitor, once per session, so orders can be compared per version even without a sign-up. */
  (function stampCart() {
    if (!counting) return;
    try { if (sessionStorage.getItem('ub_popup_cart_stamp') === label) return; } catch (e) {}
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root_ + 'cart/update.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { ub_popup_variant: label } })
    }).then(function (r) { if (r.ok) try { sessionStorage.setItem('ub_popup_cart_stamp', label); } catch (e) {} })
      .catch(function () {});
  })();

  /* ---------- Exercise films (lead Unlocked) ----------
     The home page's transparent films, played one after another 03 → 02 → 01 and
     round again; the others show their poster. Only the playing film holds a
     source, so there is never more than one decoder (transparent WebM has no
     hardware decoding). Same source rule as sections/ub-exercises.liquid. */
  var films = { list: [], i: -1, on: false, timer: 0, errors: 0 };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function filmSource(video) {
    // WebKit plays alpha only from HEVC; everything else only from VP9 WebM.
    var ua = navigator.userAgent;
    var webkit = /AppleWebKit/.test(ua) && !/(Chrome|Chromium|Edg|OPR|SamsungBrowser)\//.test(ua) && !/Android/.test(ua);
    return webkit ? { src: video.dataset.hevc, type: 'video/mp4; codecs="hvc1"' } : { src: video.dataset.webm, type: 'video/webm' };
  }
  function attachFilm(video) {
    if (video.querySelector('source')) return;
    var f = filmSource(video), source = document.createElement('source');
    source.src = f.src; source.type = f.type;
    video.appendChild(source);
    video.load();
  }
  function releaseFilm(video) {
    var source = video.querySelector('source');
    if (!source) return;
    video.pause();
    source.remove();
    video.removeAttribute('src');
    video.load(); // back to the poster, buffers let go
  }
  function playFilm(i) {
    if (!films.on) return;
    films.i = i;
    var video = films.list[i];
    attachFilm(video);
    var p = video.play();
    if (!p || !p.catch) return;
    p.catch(function (err) {
      if (!films.on || films.i !== i) return;
      if (err && err.name === 'AbortError') return; // superseded by a newer load
      if (document.hidden) {
        // background tab: start when the visitor comes back
        document.addEventListener('visibilitychange', function back() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', back);
          if (films.on && films.i === i) playFilm(i);
        });
      }
      // otherwise autoplay is blocked (e.g. iOS Low Power Mode): the posters stay
    });
  }
  function nextFilm() {
    if (!films.on) return;
    var cur = films.list[films.i];
    if (cur) releaseFilm(cur);
    playFilm((films.i + 1) % films.list.length);
  }
  function startFilms(view) {
    stopFilms();
    films.list = Array.prototype.slice.call(view.querySelectorAll('video.ubp-film'));
    if (!films.list.length || reduceMotion) return;
    films.on = true;
    films.errors = 0;
    playFilm(0);
  }
  function stopFilms() {
    films.on = false;
    clearTimeout(films.timer);
    films.list.forEach(releaseFilm);
  }
  root.querySelectorAll('video.ubp-film').forEach(function (video) {
    video.addEventListener('ended', function () { if (films.on && films.list[films.i] === video) nextFilm(); });
    video.addEventListener('error', function () {
      if (!films.on || films.list[films.i] !== video) return;
      if (++films.errors >= films.list.length) { stopFilms(); return; } // nothing loads: posters only
      clearTimeout(films.timer); films.timer = setTimeout(nextFilm, 2500);
    }, true);
  });

  /* ---------- Views ---------- */
  var modal = root.querySelector('.ubp-modal');
  var views = root.querySelectorAll('.ubp-view');
  var current = '';
  var goal = null;
  var lastFocus = null;

  function show(name) {
    current = name;
    views.forEach(function (v) { v.hidden = v.getAttribute('data-view') !== name; });
    var view = root.querySelector('[data-view="' + name + '"]');
    // the visible headline names the dialog
    root.querySelectorAll('[id="ubp-title"]').forEach(function (h) { h.removeAttribute('id'); });
    var title = view.querySelector('.ubp-h:not([hidden]), .ubp-ticket__big');
    if (title) title.id = 'ubp-title';
    modal.scrollTop = 0;
    modal.classList.toggle('ubp-modal--narrow', view.hasAttribute('data-narrow')); // mystery steps: one column
    if (name === 'lead-unlocked') startFilms(view); else stopFilms();
    var first = view.querySelector('input, .ubp-option, a.ub-btn, button.ub-btn');
    if (first && root.hasAttribute('data-open')) setTimeout(function () { first.focus({ preventScroll: true }); }, 30);
  }

  if (who.type === 'lead') {
    root.querySelectorAll('[data-view="lead-gate"] .ubp-h').forEach(function (h) {
      h.hidden = h.getAttribute('data-variant') !== who.variant;
    });
  }

  /* ---------- Open / close ---------- */
  var scrollY = 0;
  function open() {
    if (root.hasAttribute('data-open') || document.documentElement.classList.contains('ub-drawer-open')) return false;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('data-open', '');
    hideTab();
    show(who.type === 'quiz' ? (who.variant === 'mystery' ? 'mystery-goal' : 'quiz2-goal') : 'lead-gate');
    scrollY = window.pageYOffset;
    document.documentElement.style.overflow = 'hidden';
    track('Viewed');
    return true;
  }
  function close(finished) {
    if (!root.hasAttribute('data-open')) return;
    if (!finished) track('Closed');
    root.removeAttribute('data-open');
    root.hidden = true;
    stopFilms();
    document.documentElement.style.overflow = '';
    window.scrollTo(0, scrollY);
    if (finished) { store(KEY_DONE, '1'); hideTab(); }
    else { store(KEY_SNOOZE, String(Date.now() + Number(cfg('snooze-days', 30)) * 864e5)); showTab(); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  var finished = false;

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ubp-dismiss]')) { close(finished); return; }
    var opt = e.target.closest('.ubp-option[data-goal]');
    if (opt) { chooseGoal(opt); return; }
    if (e.target.closest('[data-ubp-back]')) { show(e.target.closest('.ubp-view').getAttribute('data-back')); return; }
    var go = e.target.closest('[data-ubp-go]');
    if (go && go.getAttribute('data-ubp-go') === 'cart') { e.preventDefault(); addToCart(go); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (!root.hasAttribute('data-open')) return;
    if (e.key === 'Escape') { close(finished); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(
      modal.querySelectorAll('button, a[href], input'),
      function (el) { return el.offsetParent !== null && !el.disabled; }
    );
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* ---------- Quiz ---------- */
  function chooseGoal(opt) {
    goal = { key: opt.getAttribute('data-goal'), label: opt.querySelector('span:nth-child(2)').textContent.trim() };
    var view = opt.closest('.ubp-view');
    var next = view.getAttribute('data-next'); // quiz2-email or mystery-email
    var email = root.querySelector('[data-view="' + next + '"]');
    email.setAttribute('data-back', view.getAttribute('data-view')); // "change goal" returns to the screen it came from
    email.querySelector('[data-ubp-chosen-label]').textContent = goal.label;
    email.querySelector('[data-ubp-chosen-icon]').innerHTML = opt.querySelector('.ubp-option__icon').innerHTML;
    track('Chose Goal', { goal: goal.key });
    if (!view.classList.contains('ubp-view--goal2')) { show(next); return; }
    opt.classList.add('is-picked'); // standard quiz: let the tap register before moving on
    setTimeout(function () { opt.classList.remove('is-picked'); show(next); }, 220);
  }

  /* ---------- Forms ---------- */
  root.querySelectorAll('[data-ubp-form]').forEach(function (form) {
    var input = form.querySelector('.ubp-input');
    var err = form.querySelector('.ubp-error');
    var btn = form.querySelector('.ubp-submit');
    input.addEventListener('input', function () { form.classList.remove('is-error'); err.hidden = true; });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!EMAIL_RE.test(email)) { form.classList.add('is-error'); err.hidden = false; input.focus(); return; }
      btn.classList.add('is-loading');
      var kind = form.getAttribute('data-ubp-form');
      sendLead(kind, email).catch(function (x) { if (window.console) console.warn('[ultrabooty pop-up] sign-up:', x); })
        .then(function () {
          btn.classList.remove('is-loading');
          finished = true;
          store(KEY_DONE, '1');
          track('Signed Up');
          show(kind !== 'quiz' ? 'lead-unlocked' : who.variant === 'mystery' ? 'quiz-unlocked' : 'quiz2-unlocked');
        });
    });
  });

  /* ---------- Klaviyo (client API, public key only) ---------- */
  function klaviyoPost(path, body) {
    var company = cfg('klaviyo-company', '');
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(path + ' ' + r.status + ' ' + t); });
      return r;
    });
  }
  function sendLead(kind, email) {
    var company = cfg('klaviyo-company', '');
    var list = cfg('klaviyo-list', '');
    var source = kind !== 'quiz' ? 'Popup · 3 glute exercises' : who.variant === 'mystery' ? 'Popup · Mystery offer quiz' : 'Popup · Discount goal quiz';
    // the consent line of the step the email was typed on (lead gate, quiz email or mystery email)
    var consentEl = root.querySelector('.ubp-view:not([hidden]) [data-ubp-consent]');
    var props = {
      ub_lead_source: source,
      ub_popup_variant: kind === 'quiz' ? 'quiz-' + who.variant : 'lead-' + who.variant,
      ub_marketing_consent: true,
      ub_consent_text: consentEl ? consentEl.textContent.trim() : null,
      ub_consent_at: new Date().toISOString(),
      ub_consent_source: location.pathname
    };
    if (kind === 'quiz' && goal) props.ub_quiz_goal = goal.key;
    window.dispatchEvent(new CustomEvent('ultrabooty:lead', { detail: { email: email, properties: props } }));
    // Omnisend (via the omnisend-lead endpoint, which holds the API key) replaces Klaviyo once it's set
    var omnisend = cfg('omnisend-endpoint', '');
    if (omnisend) {
      return fetch(omnisend, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email: email, properties: props })
      }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('omnisend ' + r.status + ' ' + t); });
        return r;
      });
    }
    if (!company) return Promise.resolve();
    var profile = { data: { type: 'profile', attributes: { email: email, properties: props } } };
    var work = klaviyoPost('profiles', profile);
    if (list) {
      work = work.then(function () {
        return klaviyoPost('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        });
      });
    }
    return work.then(function () {
      return klaviyoPost('events', {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: kind === 'quiz' ? 'Unlocked Popup Offer' : 'Requested 3 Glute Exercises' } } },
            profile: profile,
            properties: props
          }
        }
      });
    });
  }

  /* ---------- ORDER YOURS NOW (both pop-ups): exactly 1 unit in the cart, then the drawer ---------- */
  function addToCart(btn) {
    var id = Number(cfg('variant-id', 0));
    var drawer = document.querySelector('cart-drawer');
    if (!id) { location.href = '/cart'; return; }
    btn.classList.add('is-loading');
    track('Clicked Order Yours Now');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (i) { return i.variant_id === id; });
        if (!drawer || typeof drawer.renderContents !== 'function') {
          if (inCart) { location.href = '/cart'; return null; }
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1 })
          }).then(function () { location.href = '/cart'; return null; });
        }
        var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        if (inCart) {
          // already there: don't add a second unit, just refresh and open the drawer
          return fetch('/?sections=' + sections.join(','))
            .then(function (r) { return r.json(); })
            .then(function (s) { return { sections: s }; });
        }
        return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ id: id, quantity: 1, sections: sections, sections_url: location.pathname })
        }).then(function (r) { return r.json(); });
      })
      .then(function (state) {
        btn.classList.remove('is-loading');
        if (!state) return;
        close(true);
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        setTimeout(function () { if (typeof drawer.open === 'function') drawer.open(); }, 50);
      })
      .catch(function () { location.href = '/cart'; });
  }

  /* ---------- Light analytics hook (no-op unless something listens) ---------- */
  function track(action, extra) {
    var detail = { action: action, popup: who.type, variant: who.variant || null };
    if (extra) for (var k in extra) detail[k] = extra[k];
    window.dispatchEvent(new CustomEvent('ultrabooty:popup', { detail: detail }));
    stat(action);
  }

  /* ---------- Sticky tab (after closing without signing up) ---------- */
  function showTab() {
    if (!tab || store(KEY_DONE) === '1' || Number(store(KEY_TAB) || 0) > Date.now()) return;
    tab.querySelectorAll('[data-ubp-tab-label]').forEach(function (l) { l.hidden = l.getAttribute('data-ubp-tab-label') !== who.type; });
    // the stylesheet loads lazily: don't show an unstyled button
    var tries = 0;
    (function ready() {
      if (getComputedStyle(tab).position === 'fixed') { tab.hidden = false; return; }
      if (++tries < 50) setTimeout(ready, 100);
    })();
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-ubp-tab-open]').addEventListener('click', function () { track('Reopened From Tab'); open(); });
    tab.querySelector('[data-ubp-tab-close]').addEventListener('click', function () {
      hideTab();
      store(KEY_TAB, String(Date.now() + Number(cfg('snooze-days', 30)) * 864e5));
      track('Hid Tab');
    });
  }

  /* ---------- Trigger ---------- */
  if (forced) { if (forced === 'quiz2') setTimeout(open, 2000); else open(); return; } // quiz2: a 2 s beat after load, like a visit
  if (store(KEY_DONE) === '1') return;
  if (Number(store(KEY_SNOOZE) || 0) > Date.now()) { showTab(); return; } // closed earlier: just the tab
  if (root.getAttribute('data-logged-in') === '1') return;

  var SCROLL = Number(cfg('scroll-percent', 60));
  var FALLBACK = Number(cfg('fallback-seconds', 45));
  var fired = false;
  function fire() {
    if (fired) return;
    if (!open()) { setTimeout(fire, 3000); return; } // cart drawer open: try again shortly
    fired = true; window.removeEventListener('scroll', onScroll); clearInterval(poll);
  }
  function depth() {
    var doc = document.documentElement, body = document.body;
    var h = Math.max(doc.scrollHeight, body ? body.scrollHeight : 0) - window.innerHeight;
    if (h <= 0) return 100;
    var y = window.pageYOffset || doc.scrollTop || 0;
    return (y / h) * 100;
  }
  function onScroll() { if (depth() >= SCROLL) fire(); }
  window.addEventListener('scroll', onScroll, { passive: true });
  var poll = setInterval(onScroll, 700); // momentum scrolling throttles scroll events on phones
  if (FALLBACK > 0) setTimeout(fire, FALLBACK * 1000);
})();
